import { render, staticRenderFns } from "./collecteur_archived.vue?vue&type=template&id=4e2d9f46"
import script from "./collecteur_archived.vue?vue&type=script&lang=js"
export * from "./collecteur_archived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports